import { PartAnimatedState, PartState } from '../types';
import { curiousState } from './curious';
import { determinedState } from './determined';
import { disappointedState } from './disappointed';
import { excitedState } from './excited';
import { thinkingState } from './thinking';

// Re-export bored SVG component
export { BoredSVG } from './bored';

// Combined state parts for part-based animation
export const STATE_PARTS: Record<PartAnimatedState, PartState> = {
	curious: curiousState,
	determined: determinedState,
	thinking: thinkingState,
	disappointed: disappointedState,
	excited: excitedState,
};
